import { atom } from "jotai";

import _ from "lodash";

interface IPublishState {
  lastpublish: string | null;
  lastchange: string | null;
}

const examplePublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const tourPublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const gallowsPublishAtom = atom<IPublishState>({
  lastpublish: null,
  lastchange: null,
});

const changesSchema = JSON.stringify({
  lastchange: "string",
  lastpublish: "string",
});

export {
  gallowsPublishAtom,
  tourPublishAtom,
  examplePublishAtom,
  changesSchema,
};
export type { IPublishState };
